var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2194(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.949,
    height: 70.764,
    viewBox: "0 0 107.949 70.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 25.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10832",
    "data-name": "Path 10832",
    d: "M1.651,3.371,0,33.665,92.927,0Z",
    transform: "translate(5.777 13.438)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10953",
    "data-name": "Path 10953",
    d: "M91.6,0,0,9.245,9.5,35.278Z",
    transform: "translate(7.107 13.439)",
    fill: "#53b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10954",
    "data-name": "Path 10954",
    d: "M98.7,13.437,0,0,7.427,16.808Z",
    transform: "translate(0 0)",
    fill: "#53b1ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2194);
export default __webpack_public_path__ + "static/media/Group 2194.27b52e63499782506ab361df18df9e31.svg";
export { ForwardRef as ReactComponent };